import React from 'react'
import './ModalLoading.scss'

import RedirectIcon from 'assets/svg/redirect-icon.svg'

import Modal from 'components/Modal'

const ModalLoading = (props) => {
    return (
        <Modal className="loading-modal" open={props.open} closeBtn={false}>
            <div className="loading-modal__body">
                <img
                    className="loading-icon"
                    src={RedirectIcon}
                    alt="Redirect Alelo"
                />
                <span className="loading-modal__body--title">
                    Que bom que você voltou!
                </span>
                <span className="loading-modal__body--description">
                    Estamos recuperando a sua cesta de proposta.
                </span>
            </div>
        </Modal>
    )
}

export default ModalLoading
